import dayjs from 'dayjs';

export const formatDateMapped = (date: string | Date) => {
    const parsedDate = typeof date === 'string' ? dayjs(date, 'DD-MM-YYYY') : dayjs(date);
    return parsedDate.format('YYYY-MM-DD');
}